




import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import {
  Document,
} from "../../../domain/document";

@Component
export default class LoadedDocumentPreprocessor extends Mixins() {
  @Prop()
  document: Document;

  @Watch("document")
  onIsLoadedUpdated(newValue: Document, oldValue: Document) {
    this.preprocessLoadedDocument(newValue);
  }

  mounted(): void {
    this.preprocessLoadedDocument(this.document);
  }

  async preprocessLoadedDocument(document: Document): Promise<void> {
    if (!document) {
      return;
    }
    if (document.attributes.isTemporary && document.attributes.temporaryNote && this.$configuration.behavior.document.editor.temporaryNote.shouldShowTemporaryNoteOnEditStart) {
      await this.$commonDialogs.document.noteInput.show(false, document.attributes.temporaryNote, false, "一時保存メモ", "※後からコメントタブで確認することができます。");
    }
    // TODO: refactor 一時保存メモとあわせて一回で表示したいところではある
    if (document.attributes.externalComments && document.attributes.externalComments.length > 0) {
      for (const externalComment of document.attributes.externalComments) {
        await this.$commonDialogs.document.noteInput.show(false, externalComment.comment, false, "外部コメント", "※後からコメントタブで確認することができます。");
      }
    }
    this.$logger.info("編集準備完了");
    this.finished();
  }

  @Emit()
  finished(): void {}
}
